import { render } from "./JobspecialServiceNumber.vue?vue&type=template&id=4984d680&scoped=true"
import script from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"
export * from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"

import "./JobspecialServiceNumber.vue?vue&type=style&index=0&id=4984d680&scoped=true&lang=css"
import "./JobspecialServiceNumber.vue?vue&type=style&index=1&id=4984d680&lang=css"
script.render = render
script.__scopeId = "data-v-4984d680"

export default script